export default "__VITE_ASSET__B502HtLn__"